---
alert:
  anchorDrift:
    alarm: Das Schiff hat sich **{distance}** von der Ankerposition entfernt.
    warning: Das Schiff hat sich **{distance}** von der Ankerposition entfernt.
  depth:
    alarm: Die aktuelle Wassertiefe beträgt nur **{depth}**.
    warning: Die aktuelle Wassertiefe beträgt nur **{depth}**.
  lights:
    warning: Empfohlen ist **{recommended}**, eingetragen ist derzeit jedoch **{recorded}**.
  lostPosition:
    disconnected: Die Verbindung zur Positionsquelle wurde unterbrochen.
    invalidFix: Die Positionsquelle meldet, dass ihr GPS-Fix ungültig ist.
    jump: Die Positionsquelle meldet unplausible Positionen. Sie werden ignoriert.
    stale: Es wurden seit einiger Zeit keine Positionsdaten mehr empfangen.
  manOverboard:
    emitterActivated: Ein Mann-über-Bord-Sender wurde aktiviert. Sofortige Reaktion der gesamten Crew erforderlich.
    manualButtonActivated: Der manuelle Auslöser eines Mann-über-Bord-Senders wurde aktiviert. Sofortige Reaktion der gesamten Crew erforderlich.
    manual: Ein Crewmitglied hat manuell einen Mann-über-Bord-Alarm ausgelöst. Sofortige Reaktion der gesamten Crew erforderlich.
    unknown: Ein Mann-über-Bord-Signal wurde empfangen. Sofortige Reaktion der gesamten Crew erforderlich.

anchorMonitor:
  explanation:
    fixedRadius: |-
      Warnt dich, wenn sich das Schiff weiter als ein fest eingestellter Abstand von der Ankerposition entfernt, angegeben direkt als Radius in Metern.

      Nutze diese Methode, wenn du bereits weißt, wie viel Schwojraum du hast — zum Beispiel in einem belegten Ankerplatz, an dem du den sicheren Abstand zu Nachbarbooten oder zum Ufer selbst abgeschätzt hast.
    rodeScope: |-
      Berechnet den erwarteten Schwojradius aus der Länge deiner Ankerkette bzw. -leine, der Wassertiefe und der Länge deines Bootes, statt eines von dir selbst eingegebenen festen Abstands.

      Nutze diese Methode, wenn LOGBOOK für dich einen sinnvollen Radius anhand der ausgebrachten Kettenlänge berechnen soll — er passt sich automatisch an, wenn sich die Tiefe durch die Gezeiten ändert.
    sector: |-
      Überwacht einen gerichteten Peilungssektor statt eines vollen Kreises, sodass das Schwojen innerhalb des erwarteten Bogens ruhig bleibt, während ein Abtreiben außerhalb davon einen Alarm auslöst.

      Nutze diese Methode in einer engen Fahrrinne oder einem Flussankerplatz, wo ein Schwojen entlang der Strömung normal ist, ein seitliches Abtreiben zum Ufer oder zu einem anderen Fahrzeug jedoch nicht.

changeLog:
  '2026-09-30': |-
    Die Version 1.1 ergänzt LOGBOOK um viele neue nützliche Funktionen

    Neue Funktionen
    * Manueller Schiffsstatus - um unerwünschte Pausen-Einträge zu verhindern (automatisch aktiv bei Status "Brücke" und "Wartend")
    * Ankerwache mit Warnung und Alarm
    * Überwachung der Tiefe mit Warnung und Alarm
    * Hinweise auf laut KVR erforderlich Sichtzeichen
    * Manuelle Motor-Einträge: Hinweis auf fehlenden Eintrag für "Motor an" (kann rückwirkend gesetzt werden)
    * Warnung bei Problemen mit den NMEA-Daten
    * Mann über Bord Alarm
    * Historie der Änderungen – für eine noch erweiterte Beweissicherheit
    * Leerlauf-Drehzahl für Motoren einstellbar – Betrieb im Leerlauf wird gekennzeichnet und gilt nicht als Fahrt unter Motor

    Verbesserungen
    * Noch mehr Funktionen für manuelle Log-Einträge direkt im Log-Menü auswählbar
    * Manuelle Motor-Einträge: Drehzahl kann im Fokus-Modus nachgetragen werden
    * Personen in Crew etc. können nur am aktuellen Tag und für den nächsten Tag bearbeitet werden
    * Verbindung von Companions über Bonjour für weitere Konstellationen möglich
    * Verbesserungen am Login-Dialog mit erweiterten Fehlermeldungen
    * Umfangreiche interne Optimierungen, die die App noch schneller und zuverlässiger machen

    Fehlerkorrekturen
    * Viele größere und kleinere Optimierungen und Bug-Fixes.

  '2026-08-14': |-
    Das sind unsere Neuerungen im Update 2026-08-14:

    Neue Funktionen
    * Bei abgeschlossenen Tagen und Tagen ohne Log-Eintrag können nachträglich Einträge auf den Karten Wettervorhersage, Journal und Technisch gemacht werden.
    * Unterstützung des internen GPS unter Android
    * Warnung wenn das GPS ausfällt
    * Schnellauswahl der Segel im Menü des Log-Buttons
    * Auf Android-Geräten läuft das Primary LOGBOOK jetzt auch weiter, wenn sich die App im Hintergrund befindet
    * Anzeige der Uhrzeiten des Sonnenaufgangs und Sonnenuntergangs auf dem Tag-Datenblatt
    * Neue Optionen Brücke und Warten bei Zwischenstopp und Schiffsstatus
    * Separate Einstellung der Geschwindigkeit für das Auslösen des Starteintrags am Anker und an Boje, um unnötige Einträge beim Schwojen zu vermeiden
    * Funktionen für den Upload von Daten an den Support

    Verbesserungen
    * Neues Design der Buttons NMEA und Sync – aktueller Status besser erkennbar
    * Menü des Log-Buttons öffnet jetzt nach oben, um unnötiges Scrollen zu vermeiden
    * GPS-Fehler oder zu große Abweichungen bei der Position (u.a. durch GPS-Jamming verursacht) werden ignoriert
    * Bei kleinen Screens erscheint der Stopp-Button nur noch mit einem Icon und kann durch den Expand-Button vergrößert werden
    * Beim Wechseln der Reff-Stufe eines Segels, wird vorherige Reff-Stufe automatisch entfernt
    * Verbesserungen bei der Verbindung von Companion zum Primary, Unterstützung von Bonjour
    * Verbesserter Text bei Änderungen an Crew, Skipper etc.
    * Vom System erstellte Log-Einträge (z.B. bei Datenausfall) erscheinen nur noch einmal

    Fehlerkorrekturen
    * Zeitzone wird jetzt unter Windows auch richtig erkannt, wenn das System nicht auf Englisch als Sprache eingestellt ist
    * Mögliche Fehler in der Statistik, die bei manuellen Motoreinträgen entstehen konnten, werden mit dem Update automatisch korrigiert
    * Vom System erstellte mehrfache Log-Einträge werden mit dem Update automatisch entfernt
    * Android: Bilder können jetzt auch hochgeladen werden
    * Viele größere und kleinere Optimierungen und Bug-Fixes.

  '2026-07-15': |-
    Das sind unsere Neuerungen im Update 2026-07-15:
    
    Neue Funktionen
    * Bei manuellen Motoreinträgen (NMEA enthält keine Motordrehzahl) lässt es sich jetzt aktivieren, dass die manuell eingetragene Drehzahl automatisch in den nächsten Log-Eintrag übernommen wird. Das ist hilfreich bei Fahrten mit gleichbleibender Drehzahl. Die Option kann in den Schiffseinstellungen auf der Karte **Einstellungen** aktiviert werden.

    Verbesserungen
    * Verbesserungen und Fehlerkorrekturen bei der Statistik, insbesondere bei der Berechnung der Gesamtzeit und der Gesamtstrecke.
  
    Fehlerkorrekturen
    * Viele größere und kleinere Optimierungen und Bug-Fixes.   
    
  '2026-07-05': |-
    Das sind unsere Neuerungen im Update 2026-07-05:
    
    Neue Funktionen
    * Französisch steht als zusätzliche Sprache für das User-Interface zur Auswahl. 
    * Neuer, multifunktionaler, kontextabhängiger Log-Button neben der Log-Zeile für das schnelle Hinzufügen der unterschiedlichsten Eintragsarten.
    * In den Notes (Journal etc.) können jetzt Bilder gelöscht werden.
    * Für den Distanz-Wert aus der Logge kann in den Schiffseinstellungen ein Offset vorgegeben werden (z.B. wenn die Logge nicht die korrekten Gesamtmeilen des Schiffs anzeigt).

    Verbesserungen
    * Diverse zusätzliche Erläuterungen und Hilfestellungen im User-Interface
    * Zugriffsrechte und Crew-Rolle des Account-Inhabers sind jetzt fixiert, um Probleme mit verlorenen Zugriffsrechten zu vermeiden.
    * Bei mehreren Ergänzungen im Log-Eintrag werden jetzt alle Änderungen im Kommentar gelistet.
    * Umfangreiche Optimierungen an der LOGBOOK-Cloud und der Kommunikation zwischen LOGBOOK-Cloud und LOGBOOK-App

    Fehlerkorrekturen
    * Wenn keine Motor-Daten im NMEA vorhanden sind, werden die Motorbuttons jetzt sofort angezeigt.
    * Fehler behoben, dass bei manuellen Motor-Daten nach einer Datenunterbrechung 500 rpm eingetragen wurde.
    * Heading und Wind werden jetzt auch richtig ausgewertet, wenn nur relative Daten im NMEA enthalten sind.
    * Fehler behoben, dass es in der Statistic negative Zeiten angezeigt wurden.

  '2026-06-11': |-
    Das Update 2026-06-11 bringt viele Verbesserungen und Fehlerbehebungen:
    
    Neue Funktionen
    * Unterstützung für das iPhone als Companion-Device.
    * Auswertung zusätzlicher NMEA-Datensätze für Heading, Wind, Lufttemperatur und Luftdruck.

    Verbesserungen
    * Wenn mehrere Ergänzungen zu einem Eintrag hinzugefügt werden (z.B. Motor aus und Segel gesetzt), werden sie jetzt vollständig im Kommentar aufgelistet.
    * Der Logout vom Primary LOGBOOK ist jetzt nur noch zusammen mit dem Schließen des Primary LOGBOOK möglich.
    * Optimierte Benutzerführung durch verbesserte Hinweise, Empfehlungen und Warnungen.

    Fehlerkorrekturen
    * NMEA-Test erkennt jetzt richtig, wenn es Werte aus der Logge gibt.
    * Fehler behoben, dass auf der Karte **Tag** ein falscher Tag-Status angezeigt wurde.
    * Fehler behoben, dass nach dem Ruhezustand des Devices fehlerhafte Crew-Änderungen protokolliert wurden.
    * Fehler behoben, dass nach einer Unterbrechung der NMEA-Verbindung eine falsche Motordrehzahl eingetragen wurde.
    * Weitere Optimierungen und Fehlerbehebungen bei der Statistik.

  '2026-05-30': |-
    Das sind unsere Neuerungen im Update 2026-05-30:
    
    Neue Funktionen
    * LOGBOOK kann nun an Bord mit mehreren Geräten gleichzeitig verwendet werden. Dabei erfolgt in dieser ersten Stufe die Anmeldung auf allen Geräten mit demselben Account. Siehe hierzu in der Dokumentation unter <a href="https://logbook.yachts/site/de/documentation/#h1_devices" target="_blank">**Mehrere Devices**</a>.

    Fehlerkorrekturen
    * Fehler behoben, dass beim Drucken vereinzelt Bilder über den Druckbereich hinaus ragten.
    * Fehler behoben, dass bei westlichen Zeitzonen das falsche Datum angezeigt wurde.
    * Der aktuelle Tag zeigt jetzt immer das korrekte Datum und nicht mehr den 1. Januar an, auch wenn noch keine Einträge vorhanden sind.
    * Änderungen im Tag-Datenblatt des nächsten Tages werden nicht protokolliert.
    * Fehler behoben, dass Änderungen in der Crew protokolliert wurden, obwohl die Crew nicht geändert wurde.
    * Fehler behoben, dass bei manuellen Motoreinträgen nach einer Unterbrechung der NMEA-Verbindung eine Motordrehzahl eingetragen wurden.
    * Beim Stoppen erscheint jetzt direkt die richtige Dauer im Stopp-Button. 
    * Fehler behoben, dass bei der Tages-Statistik die Zeit und Distanz doppelt gezählt wurde.
    * iPad: Weiße Seite beim Wechsel von Cloud in App innerhalb der App behoben.

  '2026-05-20': |-
    Das sind unsere Neuerungen im Update 2026-05-20:
    
    Neue Funktionen
    * NMEA-Verbindung über UDP ergänzt.
    * Trackdaten werden laufend berechnet und regelmäßig synchronisiert, nicht erst nach dem Ende des Tages.
    * Für Tage, an denen es keinen Track gibt, wird der fehlende Track beim Neuberechnen der Statistiken (Button auf der Karte Statistik) automatisch generiert.
    * Bei manuellen Motoreinträgen bietet der Stopp-Dialog eine Option, um auch die Einträge für **Motor aus** automatisch erstellen zu lassen.

    Verbesserungen
    * Dämpfung bei der Erkennung von Pausen. Damit sollten falsche Pausen bei langsamer Fahrt oder bei Ungenauigkeiten im GPS sowie fehlerhafte Beendigungen von Pausen bei kurzfristigen Schiffsbewegungen oder GPS-Fehlern vermieden werden.
    * Die **Berechnung der Gesamtzeit** beginnt mit dem Losfahren und endet mit dem letzten Eintrag, ab dem das Schiff keine Fahrt mehr gemacht hat. Nicht die Fahrt betreffende Einträge zu Beginn und nach dem Ende werden nicht mehr berücksichtigt.

    Fehlerkorrekturen
    * Fehler behoben, dass nach dem Neustart der Navigation am selben Tag die Distanz wieder bei 0 begann.
    
  '2026-05-12': |-
    Das sind unsere Neuerungen im Update 2026-05-12:
    
    Neue Funktionen
    * iPad: Die LOGBOOK-App läuft auch im Hintergrund weiter und erstellt weiterhin Logbucheinträge, wenn die App nicht im Vordergrund ist. 
    * iPad: Fotos können jetzt direkt aus der App aufgenommen und in die Logbucheinträge eingefügt werden.
    * iPad: Unterstützung von über **Bluetooth** oder per Kabel angeschlossenen **externen GPS-Geräten**
    * Neue Funktion für **Reset**, falls Verbindung der Cloud zum Primary LOGBOOK versehentlicht getrennt wurde (erkennbar am roten Marker auf dem Sync-Button)

    Verbesserungen
    * iPad: Layout-Fehler nach der Rückkehr aus dem Hintergrund behoben
    * Server: Verbesserung bei der Berechnung der Statistiken

  '2026-05-05': |-
    Das Update 2026-05-05 behebt ein paar Fehler:
    
    * Problem mit dem intergrierten GPS des iPad behoben, das bei sehr geringen Geschwindigkeiten zu falschen Pausen-Einträgen führen konnte.
    * Problem behoben, dass eine deaktivierte NMEA-Verbindung automatisch aktiviert wurde, wenn die App auf dem iPad aus dem Hintergrund geholt wurde.
    * Fehler behoben, dass beim Ändern der Fenstergröße (z.B. durch Drehen des Tablets) die Log-Einträge und die Log-Zeile nicht korrekt angezeigt wurden
    * Fehlerhaftes Feldformat bei den Schiffsdaten auf der Karte **Ausrüstung** behoben.
    * Diverse kleinere Optimierungen am Layout 
    * Diverse kleinere Bugfixes

    Wenn du für den Datenempfang das interne GPS verwendest, findest du wichtige Infos in unserem Tipp <a href="https://logbook.yachts/site/de/support/#ipadgps" target="_blank">**»LOGBOOK mit dem internen GPS des iPad verwenden«**</a>.

  '2026-04-27': |-
    Das Update 2026-04-27 bringt eine ganze Reihe von Verbesserungen und Fehlerbehebungen. 
    Dazu gehören weitere Optimierungen des Layouts für unterschiedliche Bildschirmgrößen sowie Fehlerbehandlung beim Import aus Logbook Suite.

  '2026-04-14': |-
    Hier kommt schon das erste, kleinere Update. Folgendes haben wir verbessert:

    * Optimiertes Layout für mittlere Screens wie beispielsweise Tablet im Hochformat (768px bis 1023px) 
    * Drucken-Button funktioniert jetzt auch auf dem iPad
    * Verbesserungen beim Import aus Logbook Suite
    * Diverse kleinere Bugfixes

  '2026-04-04': |-
    Willkommen bei LOGBOOK – die innovative Logbuch-Software für Segler und Motorbootfahrer.

    Dies ist die Version 1.0. In Zukunft wirst du an dieser Stelle nach jedem Update Informationen über neue Funktionen und Verbesserungen finden.

connection: 
  interrupted: |-
    Die Verbindung zur Anwendung wurde unterbrochen. 
    
    Wenn sich die Verbindung nicht automatisch wiederherstellt, versuche bitte, die App neu zu starten.
  recovered: |-
    Die Verbindung zur Anwendung wurde wiederhergestellt. 
    
    Bitte lade neu, um die App weiter zu verwenden.

currentView:
  firstTrip: |-
    **Eine neue Etappe wird gestartet** 
    
    Bitte überprüfe die **Zeitzone**, die für diese Etappe eingestellt ist. 
    
    Die Zeitzone wird automatisch auf die Systemzeitzone des Primary Device eingestellt. Um die Zeitzone zu ändern, musst du die Systemzeitzone des Primary Device **vor** dem Start der Etappe ändern. 
  
    Sollte das System des Primary Device die Zeitzone nicht korrekt an LOGBOOK übermittelt haben, kannst du die Zeitzone in den **Schiffs-Einstellungen** auf der Karte **Einstellungen** manuell ändern. Auch dies muss **vor** dem Start der Etappe geschehen.
    
    **Bitte beachte:** Sobald die Etappe hier gestartet wird, ist die Zeitzone festgelegt.

  demoWillStart: |-
    **Hinweis:** Mit dem Start der ersten Etappe startest du auch deine 5-tägige Trial-Phase. 
    
  confirmationDialog:
    cruise: 
      allowed: |-
        Das Starten eines neuen Törns beendet den aktuellen Törn.

        Bist du sicher, dass du den aktuellen Törn stoppen und abschließen möchtest?

        **Bitte beachte**: Die NMEA-Aufzeichnung wird gestoppt.
      deniedInMotion: |-
        Das Starten eines neuen Törns ist nicht möglich, da das Schiff in Fahrt ist.
      deniedBlankExists: |-
        Das Starten eines neuen Törns ist nicht möglich, da es bereits einen leeren, noch nicht gestarteten Törn gibt.
    trip: 
      allowed: |-
        Das Starten einer neuen Etappe beendet die aktuelle Etappe.

        Bist du sicher, dass du die aktuelle Etappe stoppen und abschließen möchtest?

        **Bitte beachte**: Die NMEA-Aufzeichnung wird gestoppt.
      deniedInMotion: |-
        Das Starten einer neuen Etappe ist nicht möglich, da das Schiff in Fahrt ist.
      deniedBlankExists: |-
        Das Starten einer neuen Etappe ist nicht möglich, da es bereits eine leere, noch nicht gestartete Etappe gibt.

importShip: 
  text: |-
    So importierst du deine Logbücher aus **Logbook Suite** in **LOGBOOK**:

    **Schritt 1:** Gehe zuerst zu Logbook Suite und exportiere mit der Funktion **Export für LOGBOOK** (im Logbook Suite Manager ab Version 2.6) **Button Mehr …** alle Logbücher, die du für dein Schiff erstellt hattest. 

    **Schritt 2:** Lege in LOGBOOK ein neues Schiff mit demselben Namen an. Schließe den nach dem Erstellen angezeigten Dialog, um die Account-Einstellungen in der LOGBOOK Cloud anzuzeigen. (Dieser Schritt entfällt, falls du das Schiff bereits erstellt hast. Stelle sicher, dass das Schiff weder in der Cloud noch in der App geöffnet ist, bevor du mit Schritt 3 fortfährst.) 

    **Schritt 3:** Dein neues Schiff erscheint jetzt in der Liste. Wähle für das Schiff, in das Logbücher importiert werden sollen, **Optionen** und dann **Aus LogbookSuite importieren**. Folge den weiteren Anweisungen. (Die Importfunktion steht nur zur Auswahl, wenn das LOGBOOK des Schiffs nicht geöffnet ist.)    

    **Schritt 4:** Starte in der LOGBOOK-App einen neuen Törn, bevor du die Datenerfassung mit LOGBOOK beginnst oder fortsetzt.
        
importTrips: 
  text: |-
    Importiere Logbücher, die mit **Logbook Suite** für dein Schiff **{name}** erstellt wurden, in **LOGBOOK**. Wähle die mit dem Export-Tool von Logbook Suite erstellte Datei aus, die den folgenden Namen hat: ***[Name des Schiffs]_LOGBOOK_export.logbook***

    Falls in deinem importierten Logbuch Schiffsdaten enthalten sind, die noch nicht mit LOGBOOK erfasst wurden, werden die Daten aus Logbook Suite übernommen. Bereits in LOGBOOK eingetragene Schiffsdaten werden nicht überschrieben.

    **Wichtiger Hinweis:** Der Importvorgang kann einige Zeit in Anspruch nehmen, insbesondere wenn du ein großes Logbuch hast. Bitte sei geduldig und unterbreche den Vorgang nicht.   

    **Achtung:** Nach dem Import musst du unbedingt einen **neuen Törn starten**, bevor du die Datenerfassung in LOGBOOK startest oder fortsetzt.

login: 
  welcomeCloud: |-
    Melde dich an oder erstelle deinen Account und führe dein Schiffs-Logbuch mit LOGBOOK. 
    
    Du kannst LOGBOOK kostenlos testen und Einträge für 5 Tage erstellen.

  welcomeApp: |-
    Melde dich in der LOGBOOK-App an.
    
    Wenn du noch keinen Account hast, kannst du ihn [hier](logbook:signup) erstellen.

  welcomeAppiPad: |-
    Melde dich in der **LOGBOOK for Yachts** App für iOS an.

    Wenn du noch keinen Account hast, kannst du ihn [hier](logbook:signup) erstellen.

  signupSuccess: |-
    Dein Account wurde erstellt.

    Wir haben eine E-Mail zur Aktivierung an deine E-Mail-Adresse gesendet. Bitte folge dem Link in der E-Mail, um fortzufahren.

  invitation: |- 
    {inviter} hat dich eingeladen und möchte dir Zugriff auf sein LOGBOOK für **{ship}** geben. 
    
    Wenn du bereits einen Account für LOGBOOK eingerichtet hast, melde dich einfach bei deinem Account an. 
    
    Wenn du noch nicht bei LOGBOOK registriert bist, registriere dich bitte hier, um deinen kostenlosen Account zu erstellen. Du wirst dann direkt angemeldet.
    
    Nach der Anmeldung ist dein LOGBOOK-Account mit dem LOGBOOK-Account von {inviter} verbunden. Logge dich anschließend in die LOGBOOK-App ein. In der Schiffsliste in deinen Account-Einstellungen erscheint **{ship}** unter **Aus geteilten Schiffen auswählen** und du kannst dich direkt als Companion mit dem LOGBOOK für {ship} verbinden.

  invitationLoggedIn: |- 
    {inviter} hat dich eingeladen und möchte dir Zugriff auf sein LOGBOOK für **{ship}** geben. 
    
    Mit **Einladung annehmen** bestätigst du die Einladung. Logge dich anschließend in die LOGBOOK-App ein.In der Schiffsliste in deinen Account-Einstellungen erscheint **{ship}** unter **Aus geteilten Schiffen auswählen** und du kannst dich direkt als Companion mit dem LOGBOOK für {ship} verbinden.

    Mit **Anderen Account verwenden** kannst du auch einen anderen Account auswählen oder erstellen, um Zugriff auf das LOGBOOK für {ship} zu erhalten.

  resetAppWarning: |-
    Falls es Probleme beim Starten der App oder beim Öffnen eines Schiffs gibt, kannst du die LOGBOOK-App mit dieser Funktion zurücksetzen. 

    Dabei werden alle Daten, die auf dem Gerät gespeichert sind, gelöscht. Alle Daten, die von der LOGBOOK-App in die LOGBOOK-Cloud geladen wurden und dort gespeichert sind, bleiben erhalten. 
  
    Nach dem Zurücksetzen musst du die LOGBOOK-App neu öffnen und dich mit deinem Account anmelden. Beim Öffnen deines Schiffs lädt die LOGBOOK-App dann wieder alle Daten aus der LOGBOOK-Cloud.    
    
    **Wichtig!** Führe das Zurücksetzen der LOGBOOK-App nur aus, wenn du eine Internetverbindung hast.
    
    Bist du sicher, dass du die App zurücksetzen möchtest?

  resetAppComplete: |-
    Das Zurücksetzen der LOGBOOK-App ist abgeschlossen. 
    
    Falls die LOGBOOK-App nicht automatisch beendet wurde, musst du sie manuell über das Betriebssystem schließen (killen) und erneut starten.

logout: 
  logoutWithInternet: |-
    **Warnung – Primary LOGBOOK für {name} geöffnet**
    
    In der App ist noch das **Primary LOGBOOK {name}** geöffnet. Mit dem Logout wird das Primary LOGBOOK geschlossen. Um das Primary LOGBOOK wieder zu öffnen, ist eine Internet-Verbindung erforderlich. 

  logoutWithoutInternet: |-
    **Logout nicht möglich – keine Internet-Verbindung** 
    
    Für das Ausloggen wird eine Internet-Verbindung benötigt. Bitte überprüfe deine Verbindung und versuche es erneut.

nmeaSettings:
  connectionTypeNative: |-
    Um das **interne GPS** zu verwenden, wähle unter **NMEA-Verbindungstyp** die Option **Internes GPS**. Auf der Karte **Test und Daten** wird der GPS-Empfang über das interne GPS separat angezeigt.

    Ein **externes GPS-Gerät**, das über **Bluetooth** oder per **Kabel** an das iPad angeschlossen ist, verhält sich genauso wie das interne GPS. Wähle also für das externe GPS-Gerät ebenfalls den Verbindungstyp **Internes GPS**.
    
    Weitere verfügbare **interne Sensoren** wie beispielsweise ein **internes Barometer** können unabhängig von der Verwendung des internen GPS auf der Karte **Interne Sensoren** aktiviert werden. 

  connectionTypeNativeWarning: |-
    **Wichtiger Hinweis**

    Bei Verwendung des internen GPS solltest du, um falsche Einträge zu vermeiden, bevor du das iPad von Bord des Schiffs nimmst entweder die NMEA-Verbindung trennen oder das Primary LOGBOOK deines Schiffs über den Menübefehl schließen.

    Bitte beachte aber, dass sowohl für das Schließen des Schiffs als auch für das erneute Öffnen eine Internet-Verbindung erforderlich ist.
    
noteText:  
  uninitialized: |-
    **Synchronisation wird initialisiert**

    Bitte warte. Dies kann einige Minuten dauern.
  failed: Synchronisation fehlgeschlagen. Wird in Kürze erneut versucht.
  initialSyncFailed: Erste Synchronisation fehlgeschlagen. Wird in Kürze erneut versucht.
  initialSyncInProgress: |-
    **Erste Synchronisation gestartet**
    
    Bitte warte. Dies kann einige Minuten dauern.
  dataWaiting: Warten auf Synchronisation.
  inProgress: |-
    **Synchronisation läuft** 
    
    Bitte warte. Dies kann einige Minuten dauern.
  current: Vollständig synchronisiert.
  disconnected: |-
    **Verbindung zur LOGBOOK-Cloud verloren**

    Dieses Gerät ist nicht mehr als Primary LOGBOOK registriert, daher wurde die Synchronisation gestoppt.

    Stelle die Verbindung über **Verbindung wiederherstellen** im Menü **Sync** wieder her. Du wirst gefragt, ob die Daten auf diesem Gerät oder die Daten in der LOGBOOK-Cloud behalten werden sollen.
  transition: |-
    **Daten werden vorbereitet**

    Vorhandene Einträge werden für diese Version aktualisiert. Bitte warte, dies kann einige Minuten dauern.
  resync: |-
    Daten aus deinem Device werden in die LOGBOOK-Cloud hochgeladen.
  newShip: |-
    **Wichtiger Hinweis** 
    
    Der **Schiffstyp** und die **Anzahl der Motoren** können nach der Erstellung des Schiffs nicht mehr geändert werden.

  shipOpen: |-
    Das **Primary LOGBOOK** für **{name}** ist bereits auf einem anderen Device geöffnet. 
    
    **Fall 1 - Du bist an Bord des Schiffs**

    Stelle sicher, dass dein Device mit dem **schiffsinternen Netzwerk** verbunden ist. 
    Trage dann hier die Adresse des Primary LOGBOOK ein, um eine Verbindung herzustellen. Verwende die Form **IP:Port**, z.B. 192.168.0.100:8000. Du findest die Adresse im Primary LOGBOOK in den **Schiffseinstellungen** unter **Companions**.

  shipOpen2: |-
    ** **

    **Fall 2 - Kein schiffsinternes Netzwerk vorhanden oder du befindest dich nicht an Bord des Schiffs**
  
    Dann kannst du dir jederzeit den zuletzt synchronisierten Stand des Logbuchs in der **LOGBOOK-Cloud** ansehen.

    ** **

    **Fall 3 - Du möchtest das Logbuch als Primary LOGBOOK auf diesem Device öffnen**

    Falls nötig, kann du mit **Primary LOGBOOK trennen**, die Verbindung zwischen dem Primary LOGBOOK und der LOGBOOK-Cloud zwangsweise trennen. 
  
  shipNotClosed: |-
    Verwende diese Funktion nur, wenn du sicher bist, dass das Primary LOGBOOK von der LOGBOOK-Cloud getrennt werden muss – beispielsweise, weil das Primary Device defekt ist oder aus anderen Gründen kein Zugriff mehr auf das Primary Device möglich ist. 
    
    Alle Daten, die nach dem Trennen vom Primary LOGBOOK aufgezeichnet werden, werden nicht synchronisiert und können verloren gehen.
        
    - Wechsle mit dem Button unten zur Schiffsliste in der LOGBOOK-Cloud.
    
    - Öffne mit dem Button **Optionen** den gleichnamigen Dialog (der Button erscheint bei dem betroffenen Schiff in einer anderen Farbe). Über diesen kannst du nun das Schiff trennen.

    Nach einer kurzen Wartezeit lässt sich das Primary LOGBOOK des Schiffs dann wieder öffnen. Ggf. kannst du die Ansicht mit dem Refresh-Button aktualisieren. Das erneute Öffnen kann einige Minuten dauern, da die LOGBOOK-App alle Daten aus der LOGBOOK-Cloud abrufen muss.

  shipOpenCompanion: |-
   Trage hier die Adresse des Primary LOGBOOK ein, um eine Verbindung herzustellen. 
   
   Verwende die Form **IP:Port**, z.B. **192.168.0.100:8000**. 
   
   Du findest die Adresse im Primary LOGBOOK in den Schiffseinstellungen unter **Companions**.

  shipsSmartphone: |-
    LOGBOOK kann auf dem Smartphone nur als Companion verwendet werden und bietet daher eine eingeschränkte Funktionalität.

    Auswählbar sind nur Schiffe, deren Primary LOGBOOK bereits auf einem anderen Device läuft. Für die Companion-Verbindung muss sich dein Smartphone im selben Netzwerk wie das Primary Device befinden.

  selectShip: |-
    Schiff wird in der LOGBOOK-Cloud ausgewählt.
  selectShipFailed: |-
    Auswahl des Schiffs in der LOGBOOK-Cloud fehlgeschlagen.

    Bitte versuche es in ein paar Minuten erneut.
  limitActiveShipsReached: |-
    Du hast dein Limit an aktiven Schiffen erreicht.

    Um ein anderes Schiff auszuwählen, musst du zuerst das aktuell geöffnete Schiff in der LOGBOOK-Cloud schließen.
  startShip: |-
    <strong>Dein Schiff "{name}" wurde erstellt – Wechsel nun zur LOGBOOK-App</strong>
    
    Dein neues Schiff wurde erfolgreich erstellt und wird jetzt hier in der **LOGBOOK-Cloud** angezeigt. 
    
    Wenn du willst, kannst du direkt hier in der LOGBOOK-Cloud weitere Schiffsdaten eintragen. Wähle dafür den Menüpunkt **{name} Schiffsdaten** aus dem Menü <strong>{name}</strong>. 

    Als nächstes müssen der erste Törn und die erste Etappe vorbereitet werden. Öffne dafür dein neues Schiff in der **LOGBOOK-App**. Falls du die LOGBOOK-App noch nicht installiert hast, findest du die Download-Links hier: <a href="https://logbook.yachts/site/de/download" target="_blank">Download LOGBOOK-App</a>.  

    Sobald der erste Törn und die erste Etappe erstellt wurden, werden sie auch hier in der LOGBOOK-Cloud angezeigt. 
  firstLogin: |-
    **Willkommen bei LOGBOOK** – die innovative Logbuch-Software 
    
    **Dein Account wurde erfolgreich erstellt.**
    
    <li>Lege jetzt dein <strong>erstes Schiff</strong> an …</li>
    <li>… richte die <strong>NMEA-Verbindung</strong> ein …</li>
    <li>… und schon bist du <strong>startklar für deine erste Fahrt</strong> mit LOGBOOK.</li>

    Ausführliche Anleitungen findest du im <a href="https://logbook.yachts/site/de/documentation/#h1_quickstart" target="_blank">QuickStart</a> und in den <a href="https://logbook.yachts/site/de/demos" target="_blank">interaktiven Demos</a>.

  firstLoginCloud: |-
    Falls du die LOGBOOK-App noch nicht installiert hast, findest du die Download-Links hier: <a href="https://logbook.yachts/site/de/download" target="_blank">Download LOGBOOK-App</a>.  

sessionExpired:
  text: |-
    **Login erforderlich – keine Verbindung zur LOGBOOK Cloud**

    Die LOGBOOK Cloud akzeptiert den Login dieses Geräts nicht mehr. Es ist nichts verloren gegangen: Dein Schiff bleibt geöffnet und alle Einträge werden auf diesem Gerät gespeichert.

    Bis zum erneuten Einloggen werden keine Daten in die Cloud synchronisiert und andere Geräte sehen deine Einträge nicht.

shipClose:
  text: |-
    Bist du sicher, dass du das Primary LOGBOOK des Schiffs **{name}** schließen möchtest?

    **Dies beendet die Aufzeichnung und trennt die Verbindung zum NMEA.**

    Bitte beachte auch: Du benötigst eine **Internet-Verbindung**, wenn du später zu diesem Schiff zurückkehren möchtest!

  internet: |-
    **Schließen des Schiffs nicht möglich – keine Internet-Verbindung**
    
    Für das Schließen des Schiffs wird eine Internet-Verbindung benötigt. Bitte überprüfe deine Verbindung und versuche es erneut.

  forceWarning: |-
    **Nur auf diesem Gerät schließen?**

    Dadurch wird **{name}** lokal ohne Synchronisierung geschlossen. Das Schiff bleibt in der LOGBOOK Cloud beansprucht und muss dort manuell geschlossen werden, bevor es wieder geöffnet werden kann.

    Nicht synchronisierte lokale Daten bleiben auf diesem Gerät gespeichert.

  keepOpen: |-
    **Tipp:**
    <p>Wir empfehlen, das <strong>Primary LOGBOOK</strong> während des gesamten Törns <strong>geöffnet zu lassen</strong>. <br>
    Am Ende des Tages kannst du die App einfach beenden. <br>
    Lass das <strong>Primary LOGBOOK geöffnet</strong> und <strong>logge dich nicht aus</strong>. Der Datenempfang wird dann unterbrochen, der Status des <strong>Primary LOGBOOK</strong> bleibt aber erhalten. <br>
    Nach dem erneuten Starten der App ist das <strong>Primary LOGBOOK</strong> sofort wieder verfügbar.</p>

  noSync: |-
    Die Synchronisation mit der LOGBOOK-Cloud ist fehlgeschlagen, da dieses LOGBOOK nicht mehr in der LOGBOOK-Cloud als Primary LOGBOOK registriert ist.
    
    Wenn du das Schiff schließt, gehen alle Änderungen verloren, die noch nicht in der LOGBOOK Cloud gespeichert wurden.

    Mit **Verbindung wiederherstellen** aus dem Menü **Sync** kannst du ggf. die Verbindung zur LOGBOOK Cloud wiederherstellen, um die Daten zu synchronisieren und dann das Schiff zu schließen.
    
shipInfo:
  disconnect: |-
    Bist du sicher, dass du das Primary LOGBOOK für das Schiff **{name}** trennen möchtest?

    **Dies stoppt jede Synchronisation dieses Logbuchs mit der LOGBOOK-Cloud.**
    
    Bitte beachte auch:
    
    Falls das Primary LOGBOOK auf dem Schiff keine Internet-Verbindung hat, werden alle Daten, die nach dem Trennen aufgezeichnet werden, nicht synchronisiert und können verloren gehen.
  resync: |-
    Das Primary LOGBOOK deines Schiffs **{name}** ist nicht mehr mit der LOGBOOK-Cloud verbunden. Um diese Verbindung wiederherzustellen, müssen die Daten erneut synchronisiert werden. 
  
    Dabei werden entweder die Daten auf dem Device oder die Daten in der LOGBOOK-Cloud zurückgesetzt. Anschließend wird dieses Device als **Primary LOGBOOK** für **{name}** eingerichtet. Zuletzt werden die Daten zwischen dem Primary LOGBOOK und der LOGBOOK-Cloud synchronisiert. 

    **Achtung!** 
    
    Diese Funktion ist nur für den äußersten Notfall gedacht. Führe sie nur auf dem Device aus, das als **Primary LOGBOOK** für **{name}** eingerichtet ist. Falls das Primary LOGBOOK eigentlich auf einem anderen Device eingerichtet ist, gehen die mit diesem Device erfassten Daten ggf. verloren.
    
    * Prüfe zuerst, ob die Daten hier in der LOGBOOK-App oder in der LOGBOOK-Cloud neuer sind.

    * Entscheide dann, ob du die Daten hier in der LOGBOOK-App oder die Daten in der LOGBOOK-Cloud als aktuelle Daten behalten möchtest.

    * Wähle zum Starten des Vorgangs den passenden Button.
    
  resyncUnavailable: |-
    Das Zurücksetzen des LOGBOOK deines Schiffs **{name}** konnte nicht ausgeführt werden, da in der LOGBOOK-Cloud noch ein Device mit dem Schiff verbunden ist.

    **Wichtig:** Prüfe zuerst, ob das Primary LOGBOOK aktuell auf einem anderen Device läuft. Falls ja, starte den Vorgang von diesem anderen Device aus und führe die Schritte dort durch.

    Um hier fortzufahren, trenne die Verbindung zu diesem Device in der LOGBOOK-Cloud:

    * Wechsel mit dem Befehl **Zur LOGBOOK Cloud** aus dem **Account**-Menü in die LOGBOOK-Cloud.
    * In der LOGBOOK-Cloud ist der Button **Optionen** neben deinem Schiff blau hervorgehoben. 
    * Wähle in den Optionen **Schiff trennen**. 
    * Wechsel zurück in die LOGBOOK-App. 
    * Öffne erneut den Dialog zum Wiederherstellen der Synchronisierung. Nun kannst du wählen, welche Daten du behalten möchtest.
    
  resync_reset_local_confirm: |-
    **Möchtest du wirklich die lokalen Daten verwenden?**
    
    Diese Aktion setzt die Cloud-Daten zurück. 
    
    Diese Aktion kann nicht rückgängig gemacht werden und führt zum Verlust aller Daten, die nur in der LOGBOOK-Cloud gespeichert und nicht auf diesem Device vorhanden sind.
  resync_reset_cloud_confirm: |-
    **Möchtest du wirklich die Cloud-Daten verwenden?**
    
    Diese Aktion setzt die lokalen Daten zurück.

    Diese Aktion kann nicht rückgängig gemacht werden und führt zum Verlust aller Daten, die nur auf diesem Device gespeichert und nicht in der LOGBOOK-Cloud vorhanden sind.
shipSetting:  
  utc: |-
    **Wichtiger Hinweis** 
 
    **Bitte beachte, dass die Zeitzone für die Bordzeit nach dem Starten der Etappe für die gesamte Etappe unveränderlich ist.** Eine Änderung hier hat keine Auswirkung auf eine bereits gestartete Etappe.

  utc_info: |-
    Grundsätzlich setzt LOGBOOK die Bordzeit auf die Systemzeit des Primary Device. 
    
    In Einzelfällen kann es vorkommen, dass das System des Primary Devices die Zeitzone nicht korrekt an LOGBOOK übermittelt. In diesem Fall hast du hier die Möglichkeit, die Zeitzone für die Bordzeit manuell einzustellen.
    
  log_offset: |-
    Wurde deine Logge ausgetauscht und konnte der bisherige Loggewert nicht übernommen werden? Dann trage hier den alten Wert als Offset ein. Er wird automatisch zu den neuen Messwerten addiert, damit die Gesamtstrecke deines Schiffs korrekt weitergeführt wird.
  keep_rpm: |-
    Wenn keine Motordaten über NMEA verfügbar sind, kannst du diese Option aktivieren, damit der manuell eingegebene Drehzahlwert automatisch in den nächsten Logeintrag übernommen wird. Das ist hilfreich, wenn sich die Motordrehzahl zwischen den Einträgen nicht ändert.
  lights: |-
    Wenn aktiviert, erinnert dich LOGBOOK dezent mit einem Hinweis in der Log-Zeile, sobald die für das Schiff eingetragene Sichtzeichen nicht dem von den KVR empfohlenen für den aktuellen Fahrzustand und die Tageszeit entspricht.
    
    Es wird nie ein Alarm ausgelöst — das Eintragen der passenden Sichtzeichen schließt den Hinweis. 
    
    Lege fest, welche Lichter dein Schiff unter Segeln führt, ob die Tag-/Nachtgrenze der bürgerlichen Dämmerung oder dem Sonnenunter-/aufgang folgt und ob an den Motorkegel erinnert werden soll.
  edit_permissiveness: |-
    Legt fest, wie freizügig das Bearbeiten eines Log- oder Tageseintrags nach dem Speichern ist. Dies wirkt sich auf jeden bestehenden und zukünftigen Eintrag aus, sobald die Einstellung geändert wird — nicht nur auf danach neu angelegte Einträge.

    **Standard (streng)** — das heutige Verhalten. Ein Wert, der live per NMEA geliefert wurde (z. B. Kurs, Tiefe, Motordrehzahl, Logge, Luftdruck, Temperatur, Luftfeuchtigkeit, Wind, Kurs über Grund, Fahrt über Grund), bleibt gesperrt, bis du ihn manuell korrigierst, und ist nur kurz nach der Aufzeichnung bearbeitbar.

    Manuelle Motordrehzahlen sind von der Zeitbeschränkung ausgenommen: Sie können auch in früheren Einträgen eingegeben oder korrigiert werden. Noch als NMEA-Daten geschützte Drehzahlen bleiben gesperrt.

    **Erweitert** — hebt die Zeitbeschränkung auf, sodass per NMEA gelieferte Werte auch später noch korrigiert werden können. Werte, die noch nicht manuell korrigiert wurden, bleiben aber weiterhin geschützt.

    **Uneingeschränkt** — entfernt diesen Schutz vollständig. Jeder Wert, auch ein live per NMEA gelieferter, kann jederzeit bearbeitet werden. **Bitte mit Bedacht verwenden:** Dadurch entfällt der Hinweis, dass ein Wert automatisch von einem Sensor stammt statt manuell eingegeben oder geändert wurde — das kann für den Beweiswert deines Logbuchs relevant sein.

    Einige Felder (z. B. die Distanz) werden immer automatisch berechnet und können auf keiner Stufe direkt bearbeitet werden.

planDescriptions:
  captain: |-
    Jahresabo für Profis, Schiffslänge unter 24 m
  master_captain: |-
    Jahresabo für Profis, Schiffslänge ab 24 m
  skipper: |-
    Monats- oder Jahresabo für private Skipper
  skipper_inApp: |-
    Monatsabo für private Skipper – in-App-Kauf
  trial: |-
    5 Tage testen

subscription:
  checkoutComplete: |-
    Kauf erfolgreich abgeschlossen.

  checkoutProcessing: |-
    Kauf wird abgeschlossen...

  subscriptionMessage: |-
    Wähle den Plan aus, der am besten zu dir passt.

    Egal von welchem Gerät aus du dieses Abo erwirbst, kannst du LOGBOOK mit allen unterstützten Geräten gleichzeitig oder wechselweise verwenden (macOS, Windows, Android und iOS). Das Abo ist nicht an eine Plattform gebunden.

  subscriptionMessageiPad: |-
    Schließe ein Abo ab, um LOGBOOK nach Ende der Testphase weiter mit vollem Funktionsumfang verwenden zu können.

    Nach Ablauf der 5 kostenlosen Tage kannst du deine gespeicherten Daten nur noch ansehen und drucken. Es sind keine weiteren Einträge oder Bearbeitungen möglich.

    Das Monats-Abo **LOGBOOK Skipper** eignet sich besonders für private Skipper, die ihr Logbuch bevorzugt oder ausschließlich auf dem iPad führen möchten. Das Abo verlängert sich automatisch und ist jeweils zum Ablauf der Laufzeit kündbar.

    Dieses Abo kann auch auf anderen Plattformen verwendet werden, gleichzeitig oder wechselweise.

  demo1Day: |-
    **Trial-Phase endet in einem Tag**

    Du hast noch einen Tag Zeit, LOGBOOK kostenlos zu testen und Einträge zu erstellen.

    Danach kannst du mit einem Abo nahtlos weitermachen und dein Logbuch ohne Unterbrechung fortführen.

  demo2Days: |-
    **Trial-Phase endet in 2 Tagen**

    Du kannst noch an 2 weiteren Tagen kostenlos Einträge in LOGBOOK erstellen. 
    
    Danach kannst du mit einem Abo nahtlos weitermachen und dein Logbuch ohne Unterbrechung fortführen.

  demoEnded: |-
    **Trial-Phase beendet**

    Deine Trial-Phase ist vorbei. Mit einem Abo kannst du dein Logbuch jetzt weiterführen. Deine Testdaten speichern wir noch 6 Monate in der LOGBOOK-Cloud für dich.

  demoToday: |-
    **Trial-Phase endet heute**

    Du kannst noch heute kostenlos Einträge in LOGBOOK erstellen. 
    
    Danach endet die Trial-Phase. Mit einem Abo kannst du dein Logbuch jederzeit weiterführen.

  demoStarted: |-
    **Trial-Phase gestartet**

    Mit deinem ersten Eintrag in LOGBOOK hat deine Trial-Phase begonnen. 
    
    Du kannst jetzt an insgesamt **5 Tagen** Logbuch-Einträge erstellen.

  subscription7Days: |-
    **Abo endet in wenigen Tagen**
    
    Dein Abo läuft bald aus. Keine Sorge – die Verlängerung erfolgt automatisch, damit du dein Logbuch ohne Unterbrechung weiterführen kannst.

    Falls du dein Abo anpassen möchtest, kannst du das jederzeit tun.

  subscriptionExpired: |-
    **Abo abgelaufen**

    Dein Abo ist abgelaufen. Aber keine Sorge – alle deine Daten bleiben noch 2 Jahre sicher in der LOGBOOK-Cloud gespeichert.

    Verlängere jetzt dein Abo, um dein Logbuch weiterzuführen.

  subscriptionToday: |-
    **Abo endet heute**

    Dein Abo läuft heute aus. Verlängere es jetzt, um dein Logbuch weiterhin nutzen zu können.

  removeAccount: |-
    Bestätige das Löschen deines Accounts.

    Mit dieser Bestätigung werden das Konto "{account}" und der Benutzer "{user}" dauerhaft gelöscht. 
    
    Du verlierst den Zugriff auf alle Schiffe, Törns, Etappen und Logbucheinträge, die mit diesem Konto verbunden sind.

  removeAccountDone: |-
    Dein Account Konto "{account}" und der Benutzer "{user}" bei LOGBOOK wurde erfolgreich gelöscht.

mailer:
  footer: |-
    ---

    ![TRIMUTIC – THE LOGBOOK COMPANY](https://trimutic.com/media/trimutic_komplett-black.png "logo")

    [TRIMUTIC](https://trimutic.com) | [LOGBOOK](https://logbook.yachts) | [Datenschutz](https://logbook.yachts/site/de/privacy) | [Über uns](https://logbook.yachts/site/de/about)

    {reason}
  templates:
    signupConfirmation:
      subject: "Willkommen bei LOGBOOK – Bestätige deine E-Mail"
      footer: |-
        Diese E-Mail wurde gesendet, weil du ein Konto für LOGBOOK auf unserer Website erstellt hast.
        Wenn du kein Konto für LOGBOOK erstellt hast, kannst du diese E-Mail ignorieren.
      body: |-
        Hallo {name},

        Willkommen bei LOGBOOK - Bestätige deine E-Mail

        Klicke auf die Schaltfläche, um deine E-Mail-Adresse zu bestätigen:

        [E-Mail-Adresse bestätigen]({confirmation_link} "button")

        Dies hilft uns sicherzustellen, dass dein Konto sicher ist und du wichtige Updates über dein Logbuch erhalten kannst.
        Wenn die Schaltfläche oben nicht funktioniert, kopiere diesen Link und füge ihn in deinen Browser ein:

        {confirmation_link}

        Dieser Bestätigungslink läuft in 24 Stunden ab.
        Wenn du kein Konto bei LOGBOOK erstellt hast, kannst du diese E-Mail ignorieren.

        Mit freundlichen Grüßen,
        **Das LOGBOOK-Team**
    signupWelcome:
      subject: "Willkommen bei LOGBOOK"
      footer: |-
        Du erhältst diese E-Mail, weil du dich bei LOGBOOK registriert hast.
      body: |-
        Hallo {name},

        Willkommen bei LOGBOOK!

        Deine E-Mail-Adresse wurde erfolgreich bestätigt! 🎉\
        Dein Account ist jetzt aktiviert und einsatzbereit.

        **Und jetzt?**

        Starte direkt durch mit deinem digitalen Logbuch!\
        Mit der kostenlosen **LOGBOOK Trial** kannst du an insgesamt **5 Tagen** kostenlos Logbuch-Einträge erstellen. Die 5 Tage beginnen mit deinem ersten Log-Eintrag.

        **So geht's los:**

        1. **Lade die LOGBOOK-App herunter** und melde dich mit deinen Zugangsdaten an.

           [App herunterladen](https://logbook.yachts/site/de/download "button")

        2. **Erstelle kostenlos dein erstes Schiff** und deinen ersten Logbuch-Eintrag – komplett kostenlos.

        3. **Finde Unterstützung beim Start:**

           - Schritt-für-Schritt-Anleitung im [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)
           - Spielerisch erkunden mit unseren [interaktiven Demos](https://logbook.yachts/site/de/demos/)
           - Vollständiger Überblick in der [Dokumentation](https://logbook.yachts/site/de/docs)

        4. **Tipps & Hilfe:**

           - Praktische Tricks auf unserer [Support-Seite](https://logbook.yachts/site/de/docs/support/#tips).
           - Direkte Hilfe über das Menü **Hilfe** in der App oder Per E-Mail an contact@trimutic.com – wir antworten schnellstmöglich!

        ---

        **Gefällt dir LOGBOOK?**\
        Dann sichere dir jetzt ein Abo und führe dein Logbuch dauerhaft und ohne Unterbrechung.

        [Mehr Infos zu den Abos](https://logbook.yachts/site/de/prices "button")

        [Jetzt Abo buchen](https://logbook.yachts/app/account/subscription "button")

        **Hinweis:** Leider ist es unter iOS nicht möglich, das Abo direkt aus deinen Account-Einstellungen heraus auszuwählen. Auf dem iPad musst du dich dafür im Webbrowser (z.B. in Safari) – außerhalb der App – in dein Konto einloggen. Der Button **Jetzt Abo buchen** führt dich dann zur Abo-Auswahl.

        Bei Fragen oder Problemen steht dir unser [Support-Team](https://logbook.yachts/site/de/support) gerne zur Verfügung.

        Mit freundlichen Grüßen,\
        **Das LOGBOOK-Team**
    invited:
      subject: "Willkommen bei LOGBOOK"
      footer: |-
        Diese E-Mail wurde gesendet, weil du zu LOGBOOK eingeladen wurdest.
        Wenn du die Einladung nicht annehmen willst, kannst du diese E-Mail ignorieren.
      body: |-
        Hallo {name},

        {account_holder} hat dich zu LOGBOOK eingeladen, damit du an Bord der **{ship_name}** Zugriff auf das Logbuch bekommst.

        Klicke, um die Einladung anzunehmen, auf diesen Button:

        [Einladung annehmen]({invitation_link} "button")

        Der Button führt dich zur Registrierung und Anmeldung bei LOGBOOK.

        **Entweder einloggen …**
        Wenn du bereits einen Account bei LOGBOOK hast, kannst du dich über diesen einloggen.
        Deine E-Mail-Adresse {email} ist bereits ausgefüllt. Du kannst dich aber auch über eine andere E-Mail-Adresse einloggen.

        **... oder registrieren und Account erstellen**
        Solltest du noch keinen Account haben, kannst du dich kostenlos bei LOGBOOK registrieren.
        Dafür werden nur dein Name, deine E-Mail-Adresse und ein Passwort benötigt.
        Deine E-Mail-Adresse {email} ist bereits fest eingetragen, damit du dich ohne weitere Verifizierungen registrieren kannst.
        Trage deinen Namen ein, lege ein Passwort fest und klicke dann auf **Registrieren**.

        Wenn die Schaltfläche oben nicht funktioniert, kopiere den folgenden Link und füge ihn in deinen Browser ein:

        {invitation_link}

        Dieser Einladungslink läuft in 24 Stunden ab.

        Mit der Registierung bei LOGBOOK bist du automatisch zum unregelmäßig erscheinenden Newsletter angemeldet, der dich über Neuheiten bei LOGBOOK informiert. Du kannst dich jederzeit wieder von diesem Newsletter abmelden.

        Mit freundlichen Grüßen,
        **Das LOGBOOK-Team**
    passwordReset:
      subject: "LOGBOOK - Passwort vergessen"
      footer: |-
        Diese E-Mail wurde gesendet, weil du im Login-Dialog von LOGBOOK eine Passwort-Vergessen Anfrage gestellt hast.
        Wenn du keine Anfrage gestellt hast, kannst du diese E-Mail ignorieren.
      body: |-
        Hallo {name},

        Du hast dein Passwort vergessen?

        Kein Problem. Klicke auf den Button, um dein Passwort zurück zu setzen.

        [Passwort zurücksetzen]({reset_link} "button")

        Anschließend kannst du im Login-Dialog ein neues Passwort vergeben.

        Solltest du dich doch wieder an dein Passwort erinnern, kannst du diese E-Mail ignorieren und erneut versuchen, dich anzumelden.

        Mit freundlichen Grüßen,
        **Das LOGBOOK-Team**
    betaInvite:
      subject: "Willkommen beim Beta-Test von LOGBOOK"
      footer: |-
        Du erhältst diese E-Mail, weil du dich als Beta-Tester für LOGBOOK gemeldet hast.
      body: |-
        Hallo {name},

        Herzlich willkommen beim Beta-Test von **LOGBOOK**! Vielen Dank, dass du dir Zeit nimmst, unsere Software unter realen Bedingungen zu testen. Durch dein Feedback hilfst du uns, LOGBOOK für den produktiven Einsatz an Bord vorzubereiten.

        Zu Beginn des Beta-Tests steht LOGBOOK für Windows, macOS und ios (iPad) zur Verfügung. In Kürze werden wir auch Android ins Beta-Test-Programm aufnehmen.

        **Was ist die Aufgabe eines Beta-Testers?**

        Als Beta-Tester bekommst du Zugriff auf eine Version, die bereits funktionsfähig ist, aber noch Fehler enthalten kann. Deine Aufgaben dabei sind:

        -   Testen der Funktionen im realen Betrieb
        -   Meldung von Fehlern (Bugs)
        -   Hinweise zu Bedienung, Verständlichkeit und Nutzerfreundlichkeit
        -   Vorschläge für Verbesserungen und neue Funktionen
        -   Rückmeldung, ob die Software deine Erwartungen erfüllt

        Poste deine Fehlermeldungen, Kommentare und Ideen in unserem Betatest-Forum, das wir über Discord eingerichtet haben. Mit diesem Link bekommst du Zugang zum Forum und zum Chat: [**Anmelden bei LOGBOOK community**](https://discord.gg/nTztPF9jKE). (Auf dem iPad funktioniert der Link mit der App Discord, nicht mit dem Browser.)
        Du erreichst uns auch per E-Mail an contact@trimutic.com.

        **Im Forum posten wir auch wichtige Hinweise und Tipps, die dir beim Testen und beim Einsatz von LOGBOOK helfen. Als bitte unbedingt anmelden!**

        Wir freuen uns über jedes Feedback — kurz oder ausführlich, positiv oder kritisch. Je ehrlicher, desto besser.

        **Wie läuft der Beta-Test ab?**

        Setze LOGBOOK direkt bei deinem nächsten Trip ein und berichte uns an contact@trimutic.com oder über das Kontaktformular von deinen Erfahrungen. Füge auch gerne Screenshots bei.

        Während der Beta-Test-Phase werden wir LOGBOOK weiter verbessern, die Anmerkungen unserer Beta-Tester einfließen lassen und auch noch einige neue Funktionen hinzufügen.
        Deshalb werden wir häufiger **Updates** bereitstellen.
        Eine Info, ob ein Update verfügbar ist, erhältst du automatisch beim Starten der App oder mit dem Menüpunkt **Änderungsprotokoll** aus dem Menü **Hilfe** (in beiden Fällen Internet-Verbindung vorausgesetzt).

        Wir möchten dich bitten, Updates zeitnah auszuführen. Nur so ist sichergestellt, dass du wirklich mit der aktuellsten Version testest.

        **Was musst du als Nächstes tun?**

        1.  Melde dich als Beta-Tester bei LOGBOOK an.

        [Anmeldung als Beta-Tester](https://logbook.yachts/app/signup/beta "button")

        Wenn du dich mit **Safari** bei LOGBOOK registrieren möchtest, musst du unbedingt darauf achten, dass aktuell noch kein Feld mit der automatischen Ausfüllhlife ausgefüllt werden darf.
        Also, bitte Namen und E-Mail manuell eintippen, keine Vorschläge auswählen. Deine Eingaben werden trotzdem in deinem System gespeichert.
        Oder verwende für die Registrierung einen anderen Browser wie beispielsweise Google Chrome oder Microsoft Edge.

        2. Lade und installiere die LOGBOOK-App auf deinem primären Device, also dem Device, mit dem du die NMEA-Daten empfangen willst.

            [Download App](https://logbook.yachts/site/de/download "button")

            Wenn du dich für den Test auf dem **iPad** angemeldet hast, erhältst du zusätzlich zu dieser E-Mail auch eine E-Mail mit dem Absender TestFlight.

            **TestFlight** ist das Tool von Apple, mit dem sich nicht veröffentlichte Apps auf dem iPad ausführen und testen lassen. Installiere die App **TestFlight** ([Install TestFlight](https://testflight.apple.com/a)). Anschließend kannst du LOGBOOK mit dem Button **View in TestFlight** (in der E-Mail) in TestFlight laden und auf deinem iPad installieren.

            Danach lässt sich LOGBOOK wie jede andere App starten.

        3. Starte die App und logge dich in dein in Schritt 1 erstelltes Benutzerkonto ein.
        4. Lege dein erstes Schiff an, verbinde die App mit dem NMEA und starte dein Logbuch (siehe auch in unserem [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)).
        5. Entdecke alle Funktionen und Möglichkeiten – und teste die App unter realen Bedingungen.

        **Dein Kontakt zum LOGBOOK-Support**

        Du erreichst du unseren Support innerhalb der App über die Funktion **Support kontaktieren** im Menü **Hilfe** (Kontaktformular) oder per **E-Mail** an contact@trimutic.com. Wir helfen dir schnell und unkompliziert weiter.

        Unsere regulären Supportzeiten sind montags bis freitags von 9:00 bis 18:00 Uhr (MEZ). In vielen Fällen erreichst du uns auch außerhalb dieser Zeiten und am Wochenende.

        **Dokumentation**

        Alle wichtigen Infos und Anleitungen findest du in unserer umfangreichen [Online-Dokumentation](https://logbook.yachts/site/de/docs/intro).

        Für einen schnellen Einstieg empfehlen wir dir unseren [Quickstart]( https://logbook.yachts/site/de/docs/quickstart/).

        Gute Fahrt und immer eine Handbreit Wasser unter dem Kiel!
        **Wünscht dir dein LOGBOOK-Team**
    subscriptionWelcomeSkipper:
      subject: "Dein Abo \"LOGBOOK Skipper\" ist aktiviert"
      footer: |-
        Du erhältst diese E-Mail, weil du dich bei LOGBOOK registriert hast.
      body: |-
        Hallo {name},

        Herzlichen Glückwunsch und willkommen an Bord!

        Du hast erfolgreich das Abo **LOGBOOK Skipper** abgeschlossen. Wir freuen uns, dich in unserer Community zu begrüßen und wünschen dir viel Spaß und Erfolg mit deinem digitalen Logbuch.

        **Was musst du als Nächstes tun?**

        1.  Installiere die LOGBOOK-App auf deinem primären Device, also dem Device, mit dem du die NMEA-Daten empfangen willst. Download-Links findest du [hier](https://logbook.yachts/site/de/download).
        2.  Starte die App und logge dich in dein Benutzerkonto ein.
        3.  Lege dein erstes Schiff an, verbinde die App mit dem NMEA und starte dein Logbuch (siehe auch in unserem [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)).
        4.  Entdecke alle Funktionen und Möglichkeiten – bei Fragen hilft dir unser Support gerne weiter.

        Und falls du LOGBOOK bereits getestet hattest, kannst du einfach mit dem bereits als Test begonnen Logbuch fortfahren.

        **Dein Support-Zugang:**

        Mit dem Abo **LOGBOOK Skipper** erreichst du unseren Support innerhalb der App über die **Kontaktfunktion** im Menü Hilfe oder per **E-Mail** an contact@trimutic.com. Wir helfen dir schnell und unkompliziert weiter.

        Unsere regulären Supportzeiten sind montags bis freitags von 9:00 bis 18:00 Uhr (MEZ). In vielen Fällen erreichst du uns auch außerhalb dieser Zeiten und am Wochenende.

        **Dokumentation:**

        Alle wichtigen Infos und Anleitungen findest du in unserer umfangreichen [Online-Dokumentation](https://logbook.yachts/site/de/docs/intro).

        Für einen schnellen Einstieg empfehlen wir dir unseren [Quickstart]( https://logbook.yachts/site/de/docs/quickstart/).

        Gute Fahrt und immer eine Handbreit Wasser unter dem Kiel!
        **Wünscht dir dein LOGBOOK-Team**
    subscriptionWelcomeCaptain:
      subject: "Dein Abo \"LOGBOOK Captain\" ist aktiviert"
      footer: |-
        Du erhältst diese E-Mail, weil du dich bei LOGBOOK registriert hast.
      body: |-
        Hallo {name},

        Herzlichen Glückwunsch und willkommen an Bord!

        Du hast erfolgreich das Abo **LOGBOOK Captain** abgeschlossen. Wir freuen uns, dich in unserer Community zu begrüßen und wünschen dir viel Spaß und Erfolg mit deinem digitalen Logbuch.

        **Was musst du als Nächstes tun?**

        1.  Installiere die LOGBOOK-App auf deinem primären Device, also dem Device, mit dem du die NMEA-Daten empfangen willst. Download-Links findest du [hier](https://logbook.yachts/site/de/download).
        2.  Starte die App und logge dich in dein Benutzerkonto ein.
        3.  Lege dein erstes Schiff an, verbinde die App mit dem NMEA und starte dein Logbuch (siehe auch in unserem [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)).
        4.  Entdecke alle Funktionen und Möglichkeiten – bei Fragen hilft dir unser Support gerne weiter.

        Und falls du LOGBOOK bereits getestet hattest, kannst du einfach mit dem bereits als Test begonnen Logbuch fortfahren.

        **Dein Support-Zugang:**

        Mit dem Abo **LOGBOOK Captain** erreichst du unseren Support direkt aus der App über den Menüpunkt **Support kontaktieren** im Menü Hilfe oder per **E-Mail** an [contact@trimutic.com](mailto:contact@trimutic.com). Wir helfen dir schnell und unkompliziert weiter.

        Mit dem in deinem Abo enthaltenen **Pro-Support** hast du auch die Möglichkeit, unseren Support per Telefon oder per WhatsApp zu kontaktieren. Die exklusive Telefonnummer des Pro-Supports lautet **[+49 211 93659134](tel: 4921193659134)**.

        Verwende diesen [**Link**](https://wa.me/message/MNUAAKYACQU5A1), um dich mit unserem Pro-WhatsApp-Support-Kanal zu verbinden. Als Captain-Abonnent bieten wir dir die Möglichkeit, über diesen Kanal per WhatsApp Kontakt mit unserem Support-Team aufzunehmen:

        Unsere regulären Supportzeiten sind montags bis freitags von 9:00 bis 18:00 Uhr (MEZ). In vielen Fällen erreichst du uns auch außerhalb dieser Zeiten und am Wochenende.

        **Dokumentation:**

        Alle wichtigen Infos und Anleitungen findest du in unserer umfangreichen [Online-Dokumentation](https://logbook.yachts/site/de/docs/intro).

        Für einen schnellen Einstieg empfehlen wir dir unseren [Quickstart]( https://logbook.yachts/site/de/docs/quickstart/).

        Gute Fahrt und immer eine Handbreit Wasser unter dem Kiel!
        **Wünscht dir dein LOGBOOK-Team**
    subscriptionWelcomeMasterCaptain:
      subject: "Dein Abo \"LOGBOOK Master Captain\" ist aktiviert"
      footer: |-
        Du erhältst diese E-Mail, weil du dich bei LOGBOOK registriert hast.
      body: |-
        Hallo {name},

        Herzlichen Glückwunsch und willkommen an Bord!

        Du hast erfolgreich das Abo **LOGBOOK Master Captain** abgeschlossen. Wir freuen uns, dich in unserer Community zu begrüßen und wünschen dir viel Spaß und Erfolg mit deinem digitalen Logbuch.

        **Was musst du als Nächstes tun?**

        1.  Installiere die LOGBOOK-App auf deinem primären Device, also dem Device, mit dem du die NMEA-Daten empfangen willst. Download-Links findest du [hier](https://logbook.yachts/site/de/download).
        2.  Starte die App und logge dich in dein Benutzerkonto ein.
        3.  Lege dein erstes Schiff an, verbinde die App mit dem NMEA und starte dein Logbuch (siehe auch in unserem [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)).
        4.  Entdecke alle Funktionen und Möglichkeiten – bei Fragen hilft dir unser Support gerne weiter.

        Und falls du LOGBOOK bereits getestet hattest, kannst du einfach mit dem bereits als Test begonnen Logbuch fortfahren.

        **Dein Support-Zugang:**

        Mit dem Abo **LOGBOOK Master Captain** erreichst du unseren Support direkt aus der App über den Menüpunkt **Support kontaktieren** im Menü Hilfe oder per **E-Mail** an [contact@trimutic.com](mailto:contact@trimutic.com). Wir helfen dir schnell und unkompliziert weiter.

        Mit dem in deinem Abo enthaltenen **Pro-Support** hast du auch die Möglichkeit, unseren Support per Telefon oder per WhatsApp zu kontaktieren. Die exklusive Telefonnummer des Pro-Supports lautet **[+49 211 93659134](tel: 4921193659134)**.

        Verwende diesen [**Link**](https://wa.me/message/MNUAAKYACQU5A1), um dich mit unserem Pro-WhatsApp-Support-Kanal zu verbinden. Als Master-Captain-Abonnent bieten wir dir die Möglichkeit, über diesen Kanal per WhatsApp Kontakt mit unserem Support-Team aufzunehmen:

        Bitte teile uns mit, wann du unsere Unterstützung beim Onboarding benötigst.

        Unsere regulären Supportzeiten sind montags bis freitags von 9:00 bis 18:00 Uhr (MEZ). In vielen Fällen erreichst du uns auch außerhalb dieser Zeiten und am Wochenende.

        **Dokumentation:**

        Alle wichtigen Infos und Anleitungen findest du in unserer umfangreichen [Online-Dokumentation](https://logbook.yachts/site/de/docs/intro).

        Für einen schnellen Einstieg empfehlen wir dir unseren [Quickstart]( https://logbook.yachts/site/de/docs/quickstart/).

        Gute Fahrt und immer eine Handbreit Wasser unter dem Kiel!
        **Wünscht dir dein LOGBOOK-Team**
    trialStarted:
      subject: "Dein LOGBOOK Trial wurde gestartet"
      footer: |-
        Du erhältst diese E-Mail, weil du dich bei LOGBOOK registriert hast.
      body: |-
        Hallo {name},

        Herzlichen Glückwunsch und willkommen an Bord!

        Du hast gerade die 5-tägige Demophase von LOGBOOK gestartet. An insgesamt **5 Tagen** kannst du jetzt kostenlos Logbuch-Einträge erstellen.

        -   **Finde Unterstützung beim Start:**

        -   Schritt-für-Schritt-Anleitung im [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)
        -   Spielerisch erkunden mit unseren [interaktiven Demos](https://logbook.yachts/site/de/demos/)
        -   Vollständiger Überblick in der [Dokumentation](https://logbook.yachts/site/de/docs)

        -   **Tipps & Hilfe:**

        -   Praktische Tricks auf unserer [Support-Seite](https://logbook.yachts/site/de/docs/support/#tips).
        -   Direkte Hilfe über das Menü **Hilfe** in der App oder Per E-Mail an contact@trimutic.com – wir antworten schnellstmöglich!
        ---
        **Gefällt dir LOGBOOK?**
        Dann sichere dir jetzt ein Abo und führe dein Logbuch dauerhaft und ohne Unterbrechung.

        [Mehr Infos zu den Abos](https://logbook.yachts/site/de/prices "button")

        [Jetzt Abo buchen](https://logbook.yachts/app/account/subscription "button")

        **Hinweis:** Leider ist es unter iOS nicht möglich, das Abo direkt aus deinen Account-Einstellungen heraus auszuwählen. Auf dem iPad musst du dich dafür im Webbrowser (z.B. in Safari) – außerhalb der App – in dein Konto einloggen. Der Button **Jetzt Abo buchen** führt dich dann zur Abo-Auswahl.

        Bei Fragen oder Problemen steht dir unser [Support-Team](https://logbook.yachts/site/de/support) gerne zur Verfügung.

        Gute Fahrt und immer eine Handbreit Wasser unter dem Kiel!
        **Wünscht dir dein LOGBOOK-Team**
    trialExpiring:
      subject: "Deine LOGBOOK Trial-Phase endet bald"
      footer: |-
        Du erhältst diese E-Mail, weil du dich bei LOGBOOK registriert hast.
      body: |-
        Hallo {name},

        Es bleibt nur noch ein Tag, bis die fünftägige Testphase von LOGBOOK endet.

        **Gefällt dir LOGBOOK?**
        Dann sichere dir jetzt ein Abo und führe dein Logbuch dauerhaft und ohne Unterbrechung.

        [Mehr Infos zu den Abos](https://logbook.yachts/site/de/prices "button")

        [Jetzt Abo buchen](https://logbook.yachts/app/account/subscription "button")

        **Hinweis:** Leider ist es unter iOS nicht möglich, das Abo direkt aus deinen Account-Einstellungen heraus auszuwählen. Auf dem iPad musst du dich dafür im Webbrowser (z.B. in Safari) – außerhalb der App – in dein Konto einloggen. Der Button **Direkt zu den Abos** führt dich dann zur Abo-Auswahl.

        Bei Fragen oder Problemen steht dir unser [Support-Team](https://logbook.yachts/site/de/support) gerne zur Verfügung.

        Gute Fahrt und immer eine Handbreit Wasser unter dem Kiel!
        **Wünscht dir dein LOGBOOK-Team**
    trialExpired:
      subject: "Deine LOGBOOK Trial-Phase ist beendet"
      footer: |-
        Du erhältst diese E-Mail, weil du dich bei LOGBOOK registriert hast.
      body: |-
        Hallo {name},

        Deine LOGBOOK Trial-Phase ist beendet. Deine Testdaten speichern wir noch 6 Monate in der LOGBOOK-Cloud für dich.

        **Gefällt dir LOGBOOK?**
        Dann sichere dir jetzt ein Abo und führe dein Logbuch dauerhaft und ohne Unterbrechung.

        [Mehr Infos zu den Abos](https://logbook.yachts/site/de/prices "button")

        [Jetzt Abo buchen](https://logbook.yachts/app/account/subscription "button")

        **Hinweis:** Leider ist es unter iOS nicht möglich, das Abo direkt aus deinen Account-Einstellungen heraus auszuwählen. Auf dem iPad musst du dich dafür im Webbrowser (z.B. in Safari) – außerhalb der App – in dein Konto einloggen. Der Button **Direkt zu den Abos** führt dich dann zur Abo-Auswahl.

        Bei Fragen oder Problemen steht dir unser [Support-Team](https://logbook.yachts/site/de/support) gerne zur Verfügung.

        Gute Fahrt und immer eine Handbreit Wasser unter dem Kiel!
        **Wünscht dir dein LOGBOOK-Team**
    contact:
      subject: "LOGBOOK - Wir haben deine Nachricht erhalten"
      footer: |-
        Diese E-Mail wurde gesendet, weil du ein Kontaktformular auf unserer Website ausgefüllt hast.
        Falls du dieses Formular nicht ausgefüllt hast, kontaktiere uns bitte umgehend.
      body: |-
        Hallo {name},

        Wir haben deine Nachricht erhalten und unser Kundenservice-Team wird sich so schnell wie möglich bei dir melden.

        ### Details deiner Anfrage

        **E-Mail:** {email}

        **Art der Anfrage:** {topic}

        **Deine Frage:**

        {request}

        Diese E-Mail bestätigt, dass wir deine Nachricht erhalten haben. In der Regel antworten wir innerhalb von 1-2 Werktagen.

        Wenn du in der Zwischenzeit dringende Fragen hast, kannst du uns gerne per Antwort auf diese E-Mail kontaktieren.

        Mit freundlichen Grüßen,
        **Dein LOGBOOK Kundenservice-Team**
    betaContact:
      subject: "LOGBOOK Beta Testing - Danke"
      footer: |-
        Diese E-Mail wurde gesendet, weil du dich für das LOGBOOK Beta-Testing-Programm angemeldet hast.
        Falls du dich nicht angemeldet hast, ignoriere bitte diese E-Mail.
      body: |-
        Hallo {name},

        Vielen Dank für dein Interesse, uns beim Testen von LOGBOOK zu unterstützen!
        Wir freuen uns sehr, dich als einen unserer Beta-Tester an Bord zu haben.

        ### Deine Registrierungsdaten

        **E-Mail:** {email}

        **Betriebssystem:** {system}

        **Aktueller Logbook Suite Nutzer:** {logbooksuite}

        **Details zu deinem Schiff, NMEA-Anbindung und deinen geplanten Reisen für Anfang 2026:**
        {request}

        ### Wie geht es weiter?

        1.  **Prüfungsprozess:** Unser Team wird deine Infos und die Details zu deinem Schiff prüfen.
        2.  **Informationen:** Wir senden dir in Kürze weitere Details zum Beta-Programm.
        3.  **Beta-Zugang:** Als Tester erhälst du Download-Links und Setup-Anleitungen.
        4.  **Testphase:** Du wirst die Möglichkeit haben, LOGBOOK während deiner für Anfang 2026 geplanten Reisen zu testen.

        Wir möchten LOGBOOK mit verschiedenen Schiffskonfigurationen und NMEA-Verbindungs-Setups testen. Daher wird dein Feedback von unschätzbarem Wert sein, um LOGBOOK zur besten digitalen Logbuch-Lösung zu machen.

        Falls du in der Zwischenzeit Fragen hast, zögere bitte nicht, dich bei uns zu melden.

        Stets eine Handbreit Wasser unterm Kiel,
        **Das LOGBOOK Team**
